<template>
  <div>
    <SkeletonCard v-if="loading"></SkeletonCard>
    <div v-else>
      <LatestAnalysis v-if="!geoData" :data="data"></LatestAnalysis>
      <div class="headSectionIA">
    <span class="name">
      <translate>Reputation</translate>
    </span>
        <div class="groupText">
          <div class="first">
            <translate>Indicates brand reputation and sentiment in LLMs</translate>
          </div>
          <div class="second"><translate :translate-params="{
    numberOfPrompts
    }">Analysis based on %{numberOfPrompts} prompts.</translate></div>
        </div>
      </div>

      <div class="box">
        <span class="titleBoxIa"><translate>General sentiment</translate></span>
        <p class="subTitle"><translate>View the breakdown of favourable, neutral, and unfavourable answer of your brand in the AI.</translate>
        </p>
        <div class="grid gap-2" style="grid-template-columns: minmax(300px, 2fr) minmax(600px, 4fr);">
          <div class="">
            <div class="text-center mb-[16px]">

            </div>
            <div class="tw-flex gap-2 text-14 justify-center">
              <div class="tw-flex flex-col items-center">
                <span class=""><translate>Negatives</translate></span>
                <span class="font-medium text-negative text-24">{{ numberNegative }}</span>
              </div>
              <div class="tw-flex flex-col items-center">
                <span><translate>Neutral</translate></span>
                <span class="font-medium text-neutral text-24">{{ numberNeutral }}</span>
              </div>
              <div class="tw-flex flex-col items-center">
                <span><translate translate-context="femenino">Positive</translate></span>
                <span class="font-medium text-positive text-24">{{ numberPositive }}</span>
              </div>
            </div>
            <div class="mt-[38px]">
              <ScaleBar class="max-w-sm" :value="avgScore" />
            </div>
            <div class="text-center mt-[16px]">
              <span class="text-24 font-bold">{{ avgScore | formatNumber(0,2) }}</span>
            </div>
            <div class="tw-flex justify-center gap-2 items-center">
              <img :src="getImageByScoreLLM(avgScore)" class="w-[19px]" alt=""  />
              <span :style="{color: getColorByScore(avgScore)}" class="font-semibold text-24">
              <translate v-if="avgScore >= 0.25" translate-context="global">Favourable</translate>
              <translate v-else-if="avgScore >= -0.25 && avgScore < 0.25">Neutral</translate>
              <translate v-else-if="avgScore < -0.25" translate-context="masculino">Negative</translate>
            </span>
            </div>
          </div>
          <div>
            <div class="grid headTableIA border-b border-[#F0EFF3] pb-[12px]" style="grid-template-columns: minmax(0, 3fr) minmax(0, 7fr) minmax(0, 4fr);">
              <div class="">
                <translate>LLMs</translate>
              </div>
              <div class="justify-center tw-flex ">
                <translate>Answers</translate>
              </div>
              <div class="tw-flex gap-2 items-center flex-1 justify-center">
                <translate>Feeling</translate>
              </div>
            </div>
            <div v-for="(item, index) in sentimentGeneralByLLM" :key="index"
                 class="grid items-center  border-b border-[#F0EFF3] py-[12px]"
                 :class="{'notFound': getNotExistLLM(data,item.llm)}"
                 style="grid-template-columns: minmax(0, 3fr) minmax(0, 7fr) minmax(0, 4fr);">
              <div class="tw-flex items-center">
                <img :src="getLogoByLLM(item.llm)" />
              </div>
              <div class="">
                <BarTrheeColor
                  :percentGreen="(item.positive_count * 100 / item.total_answers)"
                  :percentOrange="(item.neutral_count * 100 / item.total_answers)"
                  :percentRed="(item.negative_count * 100 / item.total_answers)"
                  :tooltip="true"></BarTrheeColor>
              </div>
              <div class="tw-flex gap-2 items-center flex-1 justify-center">
                <img :src="getImageByScoreLLM(item.avg_score)" class="h-[14px]" alt=""  />
                <span :style="{color: getColorByScore(item.avg_score)}" class="font-semibold text-13">{{ item.avg_score | formatNumber(2,2) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="box mt-[16px]">
        <span class="titleBoxIa"><translate>Sentiment by sector dimensions</translate></span>
        <p class="subTitle"><translate>Feeling by dimension</translate></p>
        <div class="grid headTableIA grid-cols-[minmax(0,1fr)_minmax(0,2fr)_minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)] border-b border-[#F0EFF3] pb-[12px]">
          <div >
          </div>

          <div class="grid grid-cols-[minmax(0,1fr)_minmax(0,9fr)]">
            <span></span>
            <span>
                  <translate>Global sentiment</translate>
                </span>

          </div>
          <div class="text-12 text-center">

          </div>

          <div v-for="(llm, index) in llms" :key="index" class="text-center">

            <img :src="getLogoByLLM(llm)" class="h-[16px]" alt=""  />
          </div>

        </div>
        <div v-for="(item, sector) in sectorials" :key="sector" class="grid items-center text-13 grid-cols-[minmax(0,1fr)_minmax(0,2fr)_minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)] border-b border-[#F0EFF3] py-[12px]">
          <div class="font-semibold text-14">
            {{ sector }}
          </div>

          <div class="grid grid-cols-[minmax(0,4fr)_minmax(0,2fr)] gap-2 items-center">
            <BarTrheeColor
              :percentGreen="getTotalPercentBySectoral(sector, 'positive_count')"
              :percentOrange="getTotalPercentBySectoral(sector,'neutral_count')"
              :percentRed="getTotalPercentBySectoral(sector, 'negative_count')" :tooltip="true"></BarTrheeColor>
            <div class="tw-flex gap-2 items-center flex-1">
              <img :src="getImageByScoreLLM(getTotalScoreBySectoral(sector))" class="h-[14px]" alt=""  />
              <span :style="{color: getColorByScore(getTotalScoreBySectoral(sector))}" class="font-semibold text-13">{{ getTotalScoreBySectoral(sector) | formatNumber(2,2) }}</span>
            </div>

          </div>
          <div class="font-semibold text-14 text-[#707070] text-center">
          </div>
          <div v-for="(llm, index) in llms" :key="index" class="text-center tw-flex items-center gap-2 justify-center">

            <img :src="getImageByScoreLLM(item[llm]?.avg_score)" class="h-[14px]" alt=""  />
            <span :style="{color: getColorByScore(item[llm]?.avg_score)}"
                  class="font-semibold text-13"
                  v-if="item[llm]?.avg_score"
            >{{ item[llm]?.avg_score | formatNumber(2,2) }}</span>
          </div>

        </div>

      </div>

      <div class="box mt-[16px]">
        <span class="titleBoxIa">
          <translate>Analysis of indirect prompts by sentiment</translate>
        </span>
        <p class="subTitle">
          <translate>Demonstrates brand sentiment in responses to indirect prompts (which do not name the brand) in LLMs.</translate>
        </p>
        <div class="grid items-center grid-cols-[minmax(0,4fr)_minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)] border-b border-[#000]">
          <div class="font-semibold">
            <translate>Top direct Prompts</translate>

          </div>
          <div class="py-[12px] border-r border-l border-[#EEEEEE] font-semibold text-center">
            <translate>Global</translate>
          </div>
          <div v-for="(llm, index) in llms" :key="index" class="tw-flex items-center justify-center"
               :class="{'notFound': getNotExistLLM(data,llm)}">
            <div class="icoLLM text-center tw-flex items-center justify-center w-[26px]">
              <img :src="getLogoByLLM(llm, true)" class="h-[16px]" alt=""  />
            </div>
          </div>


        </div>
        <div class="scrollCustomIA">
          <div v-for="(item, index) in questionDirectOrdered" :key="index"
               class="grid items-center items-stretch text-13 grid-cols-[minmax(0,4fr)_minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)] border-b border-[#F0EFF3]">
            <div class="py-[12px] cursor-pointer linkPrompt" @click="showQuestion = true; dataQuestion = item.text">
              {{ item.text }}
            </div>
            <div class="py-[12px] border-r border-l border-[#EEEEEE] tw-flex items-center gap-2 justify-center self-stretch">
              <img :src="getImageByScoreLLM(item.metrics_analysis.sentiment.totalCalculated)" class="h-[14px]" alt=""  />
              <span :style="{color: getColorByScore(item.metrics_analysis.sentiment.totalCalculated)}" class="font-semibold text-13">
                {{ item.metrics_analysis.sentiment.totalCalculated | formatNumber(2,2) }}
              </span>
            </div>
            <div v-for="(llm, index) in llms" :key="index" class="text-center tw-flex items-center gap-2 justify-center">
              <img :src="getImageByScoreLLM(getScoreByQuestionDirectByLLM(llm, item.text))" class="h-[14px]" alt=""  />
            </div>

          </div>
        </div>


      </div>
      <ModalQuestion :data="data" :question="dataQuestion" :show="showQuestion" @update:show="showQuestion = $event"></ModalQuestion>
    </div>
  </div>
</template>
<script>
import LatestAnalysis from "@/components/IAReputation/LatestAnalysis.vue"
import MixinIAReputation from "@/mixins/iareputation.js"
import ScaleBar from '@/components/IAReputation/ScaleBar.vue'
import BarTrheeColor from "@/components/IAReputation/BarTrheeColors.vue"
import SrvIAReputationService from "@/services/iareputation.js"
import SkeletonCard from '@/components/common/skeletonCard.vue'
import ModalQuestion from "@/components/IAReputation/ModalQuestion.vue"

export default {
  components: {LatestAnalysis, BarTrheeColor, ScaleBar, SkeletonCard, ModalQuestion},
  mixins: [MixinIAReputation],
  props: ['geoData'],
  data() {
    return {
      data: null,
      loading: false,
      showQuestion: false,
      dataQuestion: null
    }
  },
  async mounted(){
    this.loading = true
    if (!this.geoData) {
      const {status, data} = await SrvIAReputationService.getReputation({brand_uuid: this.brandUUID})
      if (status === 200) {
        console.log(data)
        this.data = data
      }
    } else {
      this.data = this.geoData
    }
    this.loading = false
  },
  methods: {
    getTotalPercentBySectoral(sector, type) {
      if (!this.data) return null
      let sum = 0
      let count = 0
      Object.keys(this.data.aggregated_sentiment.by_sectoral[sector]).forEach(e => {
        sum += this.data.aggregated_sentiment.by_sectoral[sector][e][type]
        count += this.data.aggregated_sentiment.by_sectoral[sector][e].count
      })
      return (sum * 100 / count)
    },
    getTotalScoreBySectoral(sector) {
      if (!this.data) return null
      let sum = 0
      let count = 0
      Object.keys(this.data.aggregated_sentiment.by_sectoral[sector]).forEach(e => {
        sum += this.data.aggregated_sentiment.by_sectoral[sector][e].avg_score
        count ++
      })
      return sum  / count
    },
    getScoreByQuestionDirectGlobal(index) {
      if (!this.data) return null
      let score = 0
      let count = 0
      this.llms.forEach(llm => {
        if (this.data.reputation_index[llm] && this.data.reputation_index[llm].prompts_answers.direct[index]?.metrics_analysis?.sentiment?.score) {
          score += this.data.reputation_index[llm].prompts_answers.direct[index]?.metrics_analysis?.sentiment?.score
          count++
        }
      })
      return score / count
    },
    getScoreByQuestionDirectByLLM (llm, text) {
      if (!this.data || !this.data.reputation_index[llm]) return null
      return this.data.reputation_index[llm].prompts_answers.direct.filter(e => e.text === text)[0]?.metrics_analysis?.sentiment?.score
    },
    getQuestionDirectOrdered () {
      return this.topDirects.sort((a, b) => a.metrics_analysis.sentiment.totalCalculated - b.metrics_analysis.sentiment.totalCalculated)
    }
  },
  computed: {
    numberOfPrompts () {
      if (!this.data) return 0
      return this.data.reputation_index['openai'].prompts_answers.direct.length
    },
    sectorials () {
      if (!this.data) return []
      return this.data.aggregated_sentiment.by_sectoral
    },
    sentimentGeneralByLLM () {
      if (!this.data) return []
      let items = []
      this.llms.forEach(llm => {
        if (this.data.reputation_index[llm]) {
          items.push({...this.data.reputation_index[llm].metrics_results.sentiment, llm: llm})
        } else {
          items.push({positive_count: 0, negative_count:0, neutral_count:0, total_answers: 0, enhanced_sentiment_score: 0, llm: llm})
        }
      })
      return items
    },
    numberNegative () {
      if (!this.data) return 0
      let num = 0
      this.llms.forEach(llm => {
        if (this.data.reputation_index[llm] && this.data.reputation_index[llm].metrics_results.sentiment.negative_count) {
          num += this.data.reputation_index[llm].metrics_results.sentiment.negative_count
        }
      })
      return num
    },
    numberNeutral () {
      if (!this.data) return 0
      let num = 0
      this.llms.forEach(llm => {
        if (this.data.reputation_index[llm] && this.data.reputation_index[llm].metrics_results.sentiment.neutral_count) {
          num += this.data.reputation_index[llm].metrics_results.sentiment.neutral_count
        }
      })
      return num
    },
    numberPositive () {
      if (!this.data) return 0
      let num = 0
      this.llms.forEach(llm => {
        if (this.data.reputation_index[llm] && this.data.reputation_index[llm].metrics_results.sentiment.positive_count) {
          num += this.data.reputation_index[llm].metrics_results.sentiment.positive_count
        }
      })
      return num
    },
    avgScore () {
      if (!this.data) return 0
      let num = 0
      let count = 0
      this.llms.forEach(llm => {
        if (this.data.reputation_index[llm]) {
          count++
          num += this.data.reputation_index[llm].metrics_results.sentiment.avg_score
        }
      })

      return num / count

    },
    topDirects () {
      if (!this.data) return []
      let count = 0
      let sum = 0
      const llmsExist = Object.keys(this.data.reputation_index).filter(e => e !== 'aggregated_google_alignment_ia')
      this.data.reputation_index['openai'].prompts_answers.direct.forEach((q, index) => {

        this.data.reputation_index['openai'].prompts_answers.direct[index].metrics_analysis.sentiment.totalCalculated = 0
        sum = 0
        count = 0
        llmsExist.forEach(llm => {
          count++
          sum += this.data.reputation_index[llm].prompts_answers.direct[index].metrics_analysis.sentiment?.score || 0
        })
        this.data.reputation_index['openai'].prompts_answers.direct[index].metrics_analysis.sentiment.totalCalculated = sum / count
      })
      return this.data.reputation_index['openai'].prompts_answers.direct
    },
    questionDirectOrdered () {

      const val = o => Number(o?.metrics_analysis?.sentiment?.totalCalculated ?? o?.metrics_analysis?.sentiment?.totalCalulated) || 0
      return (this.topDirects || [])
        .map((x, i) => ({ x, i, v: val(x) }))       // índice para desempate estable
        .slice()
        .sort((A, B) => (A.v - B.v) || (A.i - B.i)) // comparador numérico
        .map(o => o.x).reverse()
    }
  }
}
</script>
